import BillingApi from '@/services/rest/bemob/billing';
import UserApi from '@/services/rest/bemob/user';

export class SubscriptionApi {

  error: boolean = false;
  loading: boolean = false;

  billingApi: BillingApi = new BillingApi();
  userApi: UserApi = new UserApi();

  billingInfo: any = {};

  dataInvoices: any = {};

  getSubscription() {
    return this.billingApi.getSubscriptions().then((payload: any) => {
      return Promise.resolve(payload);
    });
  }

  getUser() {
    return this.userApi.getUser()
      .then((res: any) => {
        return Promise.resolve(res);
      }).catch((err: any) => {
        return Promise.resolve(err);
      });
  }
  
  getCustomer(){
    return this.billingApi.getCustomer().then((payload: any) => {
      return Promise.resolve(payload);
    });
  }

  postUpdateBillingInfo(payload: object){
    this.loading = true;
    return this.billingApi.postUpdateBillingInfo(payload).then((payload: any) => {
      this.billingInfo = payload;
      this.loading = false;
      return Promise.resolve(payload);
    });
  }

  getPlans(){
    this.loading = true;
    return this.billingApi.getPlans().then((payload: any) => {
      this.loading = false;
      return Promise.resolve(payload);
    });
  }

  postUpdateSubscriptionsEstimated(payload: any, ignoreInterceptor: boolean = false){
    this.loading = true;
    const meta: any = {
      ignoreInterceptor: ignoreInterceptor
    };

    return this.billingApi.postUpdateSubscriptionsEstimated(payload, meta)
      .then((payload: any) => {
        this.loading = false;
        return Promise.resolve(payload);
      });
  }

  postUpdateSubscriptions(payload: any, ignoreInterceptor: boolean = false){
    this.loading = true;
    
    const meta: any = {
      ignoreInterceptor: ignoreInterceptor
    };
    
    return this.billingApi.postUpdateSubscriptions(payload, meta)
      .then((payload: any) => {
        this.loading = false;
        return Promise.resolve(payload);
      });
  }

  postUpdateCard(payload: object, ignoreInterceptor: boolean = false) {
    this.loading = true;
    const meta: any = {
      ignoreInterceptor: ignoreInterceptor
    };

    return this.billingApi.postUpdateCard(payload, meta)
      .then((payload: any) => {
        this.loading = false;
        return Promise.resolve(payload);
      });
  }

  putPromoCode(payload: object) {
    return this.billingApi.postApplyPromo(payload).then((payload: any) => {
      return payload;
    });
  }
  get() {
    this.loading = true;
    return this.billingApi.getInvoices().then((payload: any) => {
      this.dataInvoices = payload;
      this.loading = false;
      return payload
    });
  }
}

export default new SubscriptionApi();